import request from '@/utils/request'

/**
 * FBA仓设置分页列表。
 */
export function getFbaWarehouseList(params) {
    return request({
        url: '/wms/fbaWarehouse/list',
        method: 'get',
        params
    })
}

/**
 * FBA仓下拉选项（仅启用仓），供后续物流产品绑定FBA/OMS建单选仓/出库筛选使用。
 */
export function getFbaWarehouseOptions(params) {
    return request({
        url: '/wms/fbaWarehouse/options',
        method: 'get',
        params
    })
}

/**
 * 新增FBA仓。
 */
export function addFbaWarehouse(data) {
    return request({
        url: '/wms/fbaWarehouse/add',
        method: 'post',
        data
    })
}

/**
 * 修改FBA仓。
 */
export function updateFbaWarehouse(data) {
    return request({
        url: '/wms/fbaWarehouse/update',
        method: 'post',
        data
    })
}

/**
 * 删除FBA仓（物理删除）。
 */
export function deleteFbaWarehouse(id) {
    return request({
        url: '/wms/fbaWarehouse/delete',
        method: 'post',
        params: {id}
    })
}

/**
 * FBA名称是否可用（id 编辑时传、排除自身，true=可用）。
 */
export function checkFbaNameUnique(params) {
    return request({
        url: '/wms/fbaWarehouse/checkNameUnique',
        method: 'get',
        params
    })
}

/**
 * 国家列表（来自 /config/country/list，如"US美国"）。
 */
export function getCountryList() {
    return request({
        url: '/config/country/list',
        method: 'get'
    })
}